import React from 'react'
import { Button, Modal } from 'antd'
import {
  MAX_LITERS,
  MIN_LITERS,
  NEARBY_RADIUS,
} from '../main/components/RefuelModal/constants'
import { formatLiters } from '../main/components/RefuelModal/format'

interface IFGuide {
  visible: boolean
  onClose: () => void
}

/** «Як це працює» — behind the ? in the page header, for a driver who has just landed from the app. */
const Guide: React.FC<IFGuide> = ({ visible, onClose }) => (
  <Modal
    title="Як це працює"
    visible={visible}
    onCancel={onClose}
    className="wogpay-guide"
    footer={
      <Button type="primary" onClick={onClose}>
        Зрозуміло
      </Button>
    }
  >
    <ol>
      <li>
        <b>Рахунок.</b> Оберіть рахунок, з якого спишеться пальне. Під ним
        показано залишок пального на вашому акаунті.
      </li>
      <li>
        <b>АЗК.</b> Якщо застосунок передав ваше місцезнаходження, АЗК у
        радіусі {NEARBY_RADIUS} м обирається автоматично і позначається
        зеленим. Інакше знайдіть АЗК за адресою, назвою або кодом. Далі
        натисніть «Далі».
      </li>
      <li>
        <b>Колонка, пальне і літри.</b> Оберіть колонку, вид пального із
        вашого залишку та кількість літрів — від {MIN_LITERS} до{' '}
        {formatLiters(MAX_LITERS)} л за одну заправку.
      </li>
      <li>
        <b>Заправка.</b> Натисніть «Заправити». Пальне спишеться з вашого
        акаунта, а номер талона з’явиться на екрані.
      </li>
    </ol>
    <p className="wogpay-guide__note">
      Посилання персональне і діє обмежений час. Якщо сторінка повідомляє, що
      воно застаріло, відкрийте WOG Pay у застосунку WOG ще раз.
    </p>
  </Modal>
)

export default Guide
